/**
 * SortButton — tiêu đề cột bấm được để đổi thứ tự sắp xếp.
 *
 * Chủ dự án (OQ-266): *"Tại sao không làm như bên trang Tên miền đó là bấm vào
 * chữ Kết nối thì sắp xếp theo kết nối… và bỏ ô Mặc định trước đi"*.
 *
 * Câu hỏi đúng. Một ô chọn riêng cho việc sắp xếp bắt người dùng dịch từ tên cột
 * họ đang nhìn sang một mục trong danh sách thả xuống, rồi tự nhớ mình đã chọn
 * gì. Bấm thẳng vào tiêu đề thì cột nào đang sắp và theo chiều nào đều nằm ngay
 * trên cột ấy.
 *
 * Trước đây thành phần này nằm trong `DomainsPage`, nên màn Kết nối không dùng
 * lại được và phải dựng một ô chọn riêng. Tách ra là bỏ luôn lý do tồn tại của
 * cái ô ấy.
 *
 * `sort` là chuỗi `"<field>:<asc|desc>"`, đúng dạng `GET /domains` nhận, để phía
 * web và API nói cùng một ngôn ngữ.
 */

export function SortButton({
  label,
  field,
  sort,
  onSort,
  odId,
}: {
  label: string;
  field: string;
  sort: string;
  onSort: (value: string) => void;
  odId?: string;
}) {
  const [current, direction] = sort.split(':');
  const active = current === field;
  const next = active && direction === 'asc' ? `${field}:desc` : `${field}:asc`;

  return (
    <button
      type="button"
      className="btn btn-sm btn-ghost"
      style={{ padding: 0, height: 'auto', font: 'inherit' }}
      aria-sort={active ? (direction === 'asc' ? 'ascending' : 'descending') : 'none'}
      onClick={() => onSort(next)}
      {...(odId ? { 'data-od-id': odId } : {})}
    >
      {label}
      {active ? (direction === 'asc' ? ' ↑' : ' ↓') : ''}
    </button>
  );
}
